import { useRef } from 'react';
import _ from 'lodash';
import { useWatch } from 'react-hook-form';
import { useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';
import areValuesEqual from './areValuesEqual';

type Output = Record<string, unknown>;

const useWatchFields = (fields: string[]): Output => {
  const {
    formMethods,
  } = useQuestionnaireFormContext();

  const previousValueRef = useRef<Record<string, unknown>>({});
  const watchedValues = useWatch({
    control: formMethods.control,
    name: fields,
  });

  const watchedFields = fields.reduce((acc, key, index) => {
    const value = watchedValues[index];
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, unknown>);

  if (!areValuesEqual(previousValueRef.current, watchedFields)) {
    previousValueRef.current = _.cloneDeep(watchedFields);
  }
  return previousValueRef.current;
};

export default useWatchFields;
